"use strict";
import {findAllIn} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";
import asyncAppend from "@elements/async-append";
import axios from "axios";

export function init() {
    onFind('.js-async-append', function (element) {

            let pendingRequest = axios({method: 'POST', url: element.getAttribute('data-content-url') });

            asyncAppend({
                target: findAllIn('.js-async-append__result', element),
                loading: findAllIn('.js-async-append__loading', element)
            }, pendingRequest.then((x) => x.data));
    });
}